export default __webpack_public_path__ + "static/media/AboutBackground.ccc7fe28.svg";